// extracted by mini-css-extract-plugin
export var arrow = "_36-6";
export var changeItem = "_36-3";
export var changesHeader = "_36-1";
export var changesList = "_36-2";
export var container = "_36-0";
export var pathLabel = "_36-4";
export var value = "_36-7";
export var valuesContainer = "_36-5";